import { useEffect } from 'react';

interface MutationState {
  refreshCart: boolean;
  mutationsInFlight: number;
}

export interface MutationStateMachine {
  recordMutationStarted(): MutationState;
  recordMutationEnded(): MutationState;
}

export function createMutationStateMachine(): MutationStateMachine {
  let state: MutationState = {
    refreshCart: false,
    mutationsInFlight: 0,
  };

  return {
    recordMutationStarted(): MutationState {
      const inFlight = state.mutationsInFlight + 1;
      const refreshCart = inFlight > 1;
      state = {
        refreshCart,
        mutationsInFlight: inFlight,
      };
      return state;
    },
    recordMutationEnded(): MutationState {
      const nextMutationsInFlight = state.mutationsInFlight - 1;
      state = {
        refreshCart: state.refreshCart,
        mutationsInFlight: nextMutationsInFlight,
      };
      return state;
    },
  };
}

let machine: ReturnType<typeof createMutationStateMachine> | null = null;
let mountCount = 0;

export function useCartMutationStateMachine() {
  useEffect(() => {
    mountCount += 1;
    return () => {
      mountCount -= 1;
      if (mountCount === 0) {
        machine = null;
      }
    };
  }, []);

  if (machine === null) {
    machine = createMutationStateMachine();
  }

  return machine;
}
